import * as React from 'react';
import { FormattedDate } from 'react-intl';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { differenceInDays } from 'date-fns';
import { getSearchParameters } from 'modules/sapiSearch/selectors';
import { getSelectedAvailabilityDate } from 'modules/search/selectors';
import { FormattedMessageWrapper } from '@daedalus/core/src/localization/components/FormattedMessage';
import { getCheckOutDate } from '@daedalus/core/src/searchParams/validateSearchParamDates';
import { dateStringToMiddayDate } from '@daedalus/core/src/utils/date';
export enum DatesTypes {
  Search = 'search',
  Availability = 'availability',
}
interface Props {
  datesType?: DatesTypes;
  shouldWrapDates?: boolean;
}
const ShortFormattedDate = ({
  value
}: {
  value: Date;
}) => <FormattedDate value={value} month="short" day="2-digit" />;
const TextWrapper = /*#__PURE__*/styled('span')({
  name: "TextWrapper",
  class: "t141odys",
  propsAsIs: false
});
export const SoldOutBodyMessage = ({
  datesType = DatesTypes.Search,
  shouldWrapDates = false
}: Props) => {
  const searchParams = useSelector(getSearchParameters);
  const selectedAvailabilityCheckIn = useSelector(getSelectedAvailabilityDate);
  const nights = differenceInDays(dateStringToMiddayDate(searchParams?.checkOut), dateStringToMiddayDate(searchParams?.checkIn));
  const selectedAvailabilityCheckOut = getCheckOutDate(selectedAvailabilityCheckIn, nights);
  const checkInDate = dateStringToMiddayDate(datesType === DatesTypes.Search ? searchParams?.checkIn : selectedAvailabilityCheckIn);
  const checkOutDate = datesType === DatesTypes.Search ? dateStringToMiddayDate(searchParams?.checkOut) : selectedAvailabilityCheckOut;
  if (shouldWrapDates) {
    return <span>
        <FormattedMessageWrapper id="soldOutTitle" defaultMessage="Sold out" />
        <br />
        <TextWrapper>
          <ShortFormattedDate value={checkInDate} />
        </TextWrapper>
        <span> - </span>
        <TextWrapper>
          <ShortFormattedDate value={checkOutDate} />
        </TextWrapper>
      </span>;
  }
  return <FormattedMessageWrapper dataId="soldOut.messageWithDates" id="soldOut.messageWithDatesB" defaultMessage="Sold out {checkIn} - {checkOut}" values={{
    checkIn: <TextWrapper>
            <ShortFormattedDate value={checkInDate} />
          </TextWrapper>,
    checkOut: <TextWrapper>
            <ShortFormattedDate value={checkOutDate} />
          </TextWrapper>
  }} />;
};

require("./SoldOutBodyMessage.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SoldOutBodyMessage.tsx");